import { LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE } from '../actions/logout';
import { LOGIN_SUCCESS } from '../actions/login';
const INITIAL_STATE = {
  logoutSuccess: false
};

export default function logoutReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOGOUT_REQUEST:
      return INITIAL_STATE;

    case LOGOUT_SUCCESS:
      return {
        ...state,
        logoutSuccess: true
      };

    case LOGOUT_FAILURE:
      return INITIAL_STATE;

    case LOGIN_SUCCESS:
      return INITIAL_STATE;

    default:
      return state;
  }
}
